<template>
  <v-footer dark padless style="background: #34d399">
    <v-col class="text-center green accent-2" cols="12">
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon.id"
          class="content mx-4 my-1 lg:mx-4 white--text"
          :href="icon.link"
          target="_blank"
        >
          <v-icon size="24px">
            {{ icon.icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Made with ♥ by</strong>
        <a target="_blank" href="https://jorge-vicuna.gitlab.io/jorge-vicuna/">
          @jorge_vicuna</a
        >
      </v-card-text>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "PxFooter",
  data: () => ({
    icons: [
      {
        id: 0,
        icon: "mdi-linkedin",
        link: "https://www.linkedin.com/in/jorge-vicuna-valle/",
      },
      {
        id: 1,
        icon: "mdi-gitlab",
        link: "https://gitlab.com/jorge_vicuna",
      },
      {
        id: 2,
        icon: "mdi-github",
        link: "https://github.com/Jorge150896",
      },
      {
        id: 3,
        icon: "mdi-youtube ",
        link: "https://www.youtube.com/channel/UCW0m1TKKiN3Etejqx6h3Jtg",
      },
      {
        id: 4,
        icon: "mdi-facebook",
        link: "https://www.facebook.com/jorge.vicunavalle/",
      },
    ],
  }),
};
</script>
